import { Controller } from "@hotwired/stimulus"

// Puts the tabs below the title and buttons when they don't fit in one row with them.
export default class extends Controller {
  static targets = ["title"]

  connect() {
    this.width = null
    this.observer = new ResizeObserver(() => this.layout())
    this.observer.observe(this.element)
    // The web font changes how wide the tabs are.
    document.fonts.ready.then(() => {
      this.width = null
      this.layout()
    })
  }

  disconnect() {
    this.observer.disconnect()
  }

  layout() {
    // Stacking changes the height, which would notify the observer again.
    if (this.element.clientWidth === this.width) return
    this.width = this.element.clientWidth

    this.element.classList.remove("tab-page__header--stacked")
    const firstRow = this.titleTarget.offsetTop + this.titleTarget.offsetHeight / 2
    const wrapped = Array.from(this.element.children).some((child) => child.offsetTop > firstRow)
    this.element.classList.toggle("tab-page__header--stacked", wrapped)
  }
}
